import Vue from 'vue'
import VueRouter from 'vue-router'
import Layouts from '@/layouts'
Vue.use(VueRouter)

const routes = [
    {
        path: '',
        redirect: 'home',
        component: Layouts,
        children: [
            {
                path: '/home',
                meta: { title: 'Home', icon: '' },
                component: () => import('@/views/home'),
            },
            {
                path: '/Statistics',
                meta: { title: 'Numerical Statement', icon: '' , Show: true },
                component: () => import('@/views/Statistics'),
            },
            {
                path: '/Referral',
                meta: { title: 'Recommendation', icon: '', Show: true  },
                component: () => import('@/views/Referral'),
            },
            {
                path: '/UserReferral',
                meta: { title: 'User Referral', icon: '' , Show: true },
                component: () => import('@/views/UserReferral'),
            },
            {
                path: '/Task',
                meta: { title: 'Mission', icon: '', Show: true  },
                component: () => import('@/views/Task'),
            },
            {
                path: '/withdrawalManagement',
                meta: { title: 'Withdrawing Funds', icon: '' , Show: true },
                component: () => import('@/views/withdrawalManagement'),
            },
            {
                path: '/questions',
                meta: { title: 'Answer Sheet', icon: '', Show: true  },
                component: () => import('@/views/questions'),
            },
            {
                path: '/DistributeGoldCoins',
                meta: { title: 'Activity Rewards', icon: '' , Show: true },
                component: () => import('@/views/DistributeGoldCoins'),
            },
        ],
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login'),
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})
const whiteList = ['/login']
// 前置路由拦截器
router.beforeEach((to, from, next) => {
  let roleId = localStorage.getItem('roleId')
  router.options.routes[0].children.forEach((item, index) => {
    if (index > 1 && roleId == 2) {
      item.meta.Show = false
    } else {
      item.meta.Show = true
    }
  });

    // 设置当前页签名称
    document.title = to.name || process.env.VUE_APP_TITLE
    if (whiteList.indexOf(to.path) !== -1) {
        next()
    } else {
        if (localStorage.getItem('token')) {
            next()
        } else {
            next('/login')
        }
    }
})

export default router
